import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { LanguageResultList } from '@utils/types/shared/language.ts';

async function models(): Promise<LanguageResultList> {
  const { data } = await Axios.get(GET_URL().models);
  return data;
}

async function trainableModels(): Promise<LanguageResultList> {
  const filterParam = encodeURIComponent('is_trainable:eq:true');
  const { data } = await Axios.get(GET_URL().models + `?filter=${filterParam}`);
  return data;
}

export function useGetModels() {
  return useQuery<LanguageResultList>(['models'], models);
}

export function useGetTrainableModels() {
  return useQuery<LanguageResultList>(['trainable-models'], trainableModels);
}
